module.exports = __webpack_public_path__ + "img/breath_gary.ce59a0cb.png";